/**
 * Cómo se escribe una cita en cada idioma.
 *
 * Vive en `shared` porque la escriben los dos lados: el API la mete en la lista de fuentes y la web
 * la pinta al lado de cada [n]. Si cada uno la formatease a su manera, el usuario vería dos formas
 * distintas de la misma fuente en la misma pantalla.
 *
 * Es deliberadamente austera: editor, año, página y nada más. Athena no publica veredictos sobre las
 * fuentes (plan/PLAN.md § 1), así que la cita no adorna ni califica.
 */
const COMO_SE_DICE_PAGINA = {
    es: n => `pág. ${String(n)}`,
    en: n => `p. ${String(n)}`,
};
/**
 * "AUMA, 2025, pág. 13" en español; "AUMA, 2025, p. 13" en inglés.
 *
 * Sin página y sin localizador, la cita se queda en el editor y el año: una fuente web sin
 * paginación no tiene dónde mandar al lector dentro del documento, y **inventarse un sitio sería
 * peor que no decirlo**.
 */
export function formatearCita(fuente, idioma) {
    const partes = [fuente.editor];
    if (fuente.anio !== null)
        partes.push(String(fuente.anio));
    if (fuente.pagina !== null)
        partes.push(COMO_SE_DICE_PAGINA[idioma](fuente.pagina));
    else if (fuente.localizador !== null && fuente.localizador.trim().length > 0)
        partes.push(fuente.localizador.trim());
    return partes.join(', ');
}
/**
 * El enlace que abre el documento por la página del dato. Es la promesa que la comprobación 5 de
 * Iván ejecuta a mano, así que sin página no se inventa un ancla: se devuelve la URL a secas.
 */
export function enlaceAlDocumento(urlDocumento, pagina) {
    if (pagina === null)
        return urlDocumento;
    return `${urlDocumento}#page=${String(pagina)}`;
}
//# sourceMappingURL=index.js.map